import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Truck, RotateCcw, ShieldCheck, Mail, BadgePercent } from 'lucide-react';
import { shopApi } from '../lib/shop';

const COLS = [
  { title: 'Shop', links: [['/shop', 'All Products'], ['/shop/men', 'Men'], ['/shop/women', 'Women'], ['/shop/unisex', 'Unisex'], ['/shop/heritage', 'Historical Designs'], ['/shop/limited', 'Limited Edition']] },
  { title: 'Help', links: [['/contact', 'Contact Us'], ['/faq', 'FAQ'], ['/size-guide', 'Size Guide'], ['/shipping', 'Shipping'], ['/returns', '7-Day Replacement']] },
  { title: 'Company', links: [['/our-story', 'Our Story'], ['/privacy-policy', 'Privacy Policy'], ['/terms', 'Terms of Use'], ['/cancellation-refund', 'Cancellation & Refund']] },
];

const PERKS = [
  [Truck, 'Free delivery all over India', 'On orders of ₹799 and above'],
  [RotateCcw, '7-day replacement', 'No questions asked'],
  [BadgePercent, 'No hidden charges', 'GST included, no platform or processing fee'],
  [ShieldCheck, 'Secure payments', 'Powered by Razorpay'],
];

export const ShopFooter = () => {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    await shopApi.subscribeNewsletter(email);
    setDone(true); setEmail('');
  };
  return (
    <footer className="mt-12" data-testid="shop-footer">
      <div className="bg-white border-y border-[var(--si-line)]">
        <div className="max-w-7xl mx-auto px-6 py-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {PERKS.map(([Icon, t, s]) => (
            <div key={t} className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-full bg-[#EEF2FB] flex items-center justify-center"><Icon className="w-5 h-5 text-[var(--si-navy)]" /></span>
              <div><p className="text-sm font-bold text-[var(--si-black)]">{t}</p><p className="text-xs text-[var(--si-grey)]">{s}</p></div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-[var(--si-navy)] text-white">
        <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <div className="inline-block bg-white rounded-md px-3 py-2"><img src="/scholar-logo-mark.png" alt="Scholar Industry" className="h-12 w-auto" /><p className="text-sm font-bold italic text-[var(--si-navy)]">Every Design Has a Story for You</p></div>
            <p className="mt-4 text-sm text-white/85 max-w-sm leading-relaxed">Everyday clothing and heritage-inspired designs. Every design has a story for you.</p>
            <form onSubmit={submit} className="mt-5 flex max-w-sm" data-testid="footer-newsletter-form">
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address" required
                className="flex-1 min-w-0 h-11 px-3 rounded-l-md text-sm text-[var(--si-black)] focus:outline-none" data-testid="footer-newsletter-email" />
              <button type="submit" className="h-11 px-4 rounded-r-md bg-[var(--si-yellow)] hover:bg-[#F08C00] text-white text-sm font-bold flex items-center gap-1.5" data-testid="footer-newsletter-submit">
                <Mail className="w-4 h-4" /> Subscribe
              </button>
            </form>
            {done && <p className="mt-2 text-sm text-[#86EFAC]" data-testid="footer-newsletter-success">Thanks! You're subscribed.</p>}
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <p className="text-xs font-bold uppercase tracking-wider text-white/60 mb-4">{c.title}</p>
              <ul className="space-y-2.5 text-sm">
                {c.links.map(([to, l]) => <li key={to}><Link to={to} className="text-white hover:text-[var(--si-yellow)] transition-colors">{l}</Link></li>)}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/15">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-wrap justify-between gap-3 text-xs text-white/75">
            <span>© {new Date().getFullYear()} Scholar Industry. All rights reserved.</span>
            <span>Questions? info@scholarindustry.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ShopFooter;
